<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="9" cy="8" r="3" />
  <path d="M2 21a7 7 0 0 1 14 0" />
  <path d="M17 6a3 3 0 0 1 0 6" />
  <path d="M21 21a5.5 5.5 0 0 0-4-5.3" />
</svg></template>

<script>
export default {}
</script>